import empireDesktop from "../../../assets/images/partners/empire.svg";
import empireMobile from "../../../assets/images/partners/empire.png";

const Hero = ({ isMobile }) => (
  <div
    style={{
      backgroundImage: `url(${isMobile ? empireMobile : empireDesktop})`,
    }}
    className="h-screen md:h-140 lg:h-screen bg-no-repeat bg-top bg-cover flex flex-col justify-center items-center relative -top-16 md:-top-3 lg:-top-6 xl:-top-12"
  >
    <div className="w-5/6 md:w-3/4 mx-auto mt-14 xl:mt-20 xl:-mb-16 relative z-10">
      <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-white mb-4 md:mb-10 text-center">
        Our Suppliers
      </h2>

      <p className="text-xs md:text-sm lg:text-base xl:text-xl bg-blue-750 bg-opacity-50 text-white p-6">
      NABAZAT AL QALB is representing several multinational pharmaceutical companies to make critical business decisions, as a result procurement objectives will be obtained. 

Our suppliers: Ruxall, Pro Bio Pharma, Gricar, Medcell, Belco Phrama, Juta Vit and Bhargava Phytolab.
      </p>
    </div>
  </div>
);

export default Hero;
